import React, { Component } from 'react'
import Collapsible from 'react-collapsible'
import FixedView from '../../components/FixedView'
import { checkTranslation, conditionalWidth, translate } from '../../utils/useful'
import SelectInput from '../../components/inputs/SelectInput'
import FormViewer from '../../components/FormViewer'



export default class EmailNew extends Component {
    state = {
        tools: [
            { title: "{{lang}}mail.Format", key: "format", item: [{ name: 'test' }] },
            { title: "{{lang}}mail.Insert", key: "insert" },
            { title: "{{lang}}mail.Draw", key: "draw" },
            { title: "{{lang}}mail.Options", key: "option" },
        ],
        showformat: {},
        cc: false,
        bcc: false,
        headers: [
            { key: 'from', type: 'SelectInput', information: { type: 'api', address: 'getMailAccounts', filter: {}, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}accounts', required: true } },
            { key: 'to', type: 'TextInput', information: { placeholder: '{{lang}}to', required: true } },
            { key: 'subject', type: 'TextInput', information: { placeholder: '{{lang}}subject', required: true } },
            { key: 'body', type: 'EditorInputNew', information: { placeholder: '{{lang}}body', required: true } },
        ],
        body: ''
    }


    sendMail = () => {
        let data = this.form.getForm()
        if (data) {
            console.log('dataisss', data, this.props.sendMail)
            if (this.props.sendMail) {
                this.props.sendMail(data)
            }
        }
    }
    setBody = (event) => {
        this.setState({ body: event.target.value })
    }
    render() {
        let mail = this.state.mail
        return (
            <div className='h-100 scroll-no-scrollbar w-100'>
                <div>
                    <FormViewer ref={el => this.form = el} headers={this.state?.headers} formClass="modern" inputClass={'modern-input'} />
                    {/* <div className='flexc mx-3 py-2' style={{ borderBottom: "1px solid #eee" }}>
                        <div style={{ width: '65px' }}>
                            <p className='gray-600 font-size-14'>{translate('mail.From')} :</p>
                        </div>
                        <FormViewer ref={el => this.form = el} headers={this.state?.headers} formClass="modern" inputClass={'modern-input'} />
                        <input className='email-input mld-2' style={{ width: '100%' }}></input>
                    </div>
                    <div className='flexcb mx-3 py-2' style={{ borderBottom: "1px solid #eee" }}>
                        <div className='flexc' style={{ width: '100%' }}>
                            <div style={{ width: '65px' }}>
                                <p className='gray-600 font-size-14' style={{ color: '#000' }}>{translate('mail.To')} :</p>
                            </div>
                            <input className='email-input mld-2' style={{ width: '100%' }}></input>
                        </div>
                        <div className='flexc' style={{}}>
                            <div style={{ display: this.state.cc ? 'none' : 'flex', }}>
                                <button onClick={() => { this.setState({ cc: true }) }} className='br-10 mx-1' style={{ backgroundColor: '#f4f6f8', border: '1px solid #eee' }}>
                                    <p className='font-size-12 px-2' style={{ color: '#94989c' }}>{translate('mail.+Cc')}</p>
                                </button>
                            </div>
                            <div style={{ display: this.state.bcc ? 'none' : 'flex', }}>
                                <button onClick={() => { this.setState({ bcc: true }) }} className='br-10 mx-1' style={{ backgroundColor: '#f4f6f8', border: '1px solid #eee' }}>
                                    <p className='font-size-12 px-2' style={{ color: '#94989c' }}>{translate('mail.+Bcc')}</p>
                                </button>
                            </div>
                        </div>
                    </div>
                    {this.state.cc &&
                        <div className='flexcb mx-3 py-2' style={{ borderBottom: "1px solid #eee" }}>
                            <div className='flexc' style={{ width: '100%' }}>
                                <div style={{ width: '65px' }}>
                                    <p className='gray-600 font-size-14'>{translate('mail.Cc :')}</p>
                                </div>
                                <input className='email-input mld-2' style={{ width: '100%' }}></input>
                            </div>
                            <button className='px-2 flexc' style={{}} onClick={() => { this.setState({ cc: false }) }}>
                                <img src='assets/icons/email/cancel.svg' style={{ width: '20px' }} />
                            </button>
                        </div>
                    }
                    {this.state.bcc &&
                        <div className='flexcb mx-3 py-2' style={{ borderBottom: "1px solid #eee" }}>
                            <div className='flexc' style={{ width: '100%' }}>
                                <div style={{ width: '65px' }}>
                                    <p className='gray-600 font-size-14'>{translate('mail.Bcc :')}</p>
                                </div>
                                <input className='email-input mld-2' style={{ width: '100%' }} />
                            </div>
                            <button className='px-2 flexc' style={{}} onClick={() => { this.setState({ bcc: false }) }}>
                                <img src='assets/icons/email/cancel.svg' style={{ width: '20px' }} />
                            </button>
                        </div>
                    }
                    <div className='flexc mx-3 py-2' style={{ borderBottom: "1px solid #eee" }}>
                        <div style={{ width: '65px' }}>
                            <p className='gray-600 font-size-14'>{translate('mail.Subject')} :</p>
                        </div>
                        <input className='email-input mld-2' style={{ width: '100%' }}></input>
                    </div> */}
                    <div className='' style={{ position: "sticky", top: 0 }}>
                        <div className='p-2 flexcb w-100' style={{ backgroundColor: '#f5f7f8' }} ref={el => this.moreOption = el}>
                            {/* <div className='w-100 flexc' >
                                <div className='flexc prd-2'>
                                    <button className='flexcc dark-blur-hover p-1 br-5'>
                                        <img width={20} src='/assets/icons/note/arrow.uturn.left.svg' />
                                    </button>
                                    <button className='flexcc dark-blur-hover p-1 br-5'>
                                        <img width={20} src='/assets/icons/note/arrow.uturn.right.svg' />
                                    </button>
                                </div>
                                <div className='flexc px-2' style={{ borderLeft: '1px solid #ddd' }} >
                                    <button className='flexcc dark-blur-hover pld-2 prd-1 py-1 br-5' ref={el => this.pageSize = el} onClick={() => this.sizeView.showView()}>
                                        <p className='main-c3 mrd-3' style={{ whiteSpace: 'nowrap' }}>100%</p>
                                        <img width={20} src='/assets/icons/note/arrowtriangle.down.fill.svg' />
                                    </button>
                                </div>
                                <div className={" px-2 " + conditionalWidth(this.props.width, { xs: ' d-block ' })} style={{ borderLeft: '1px solid #ddd' }}>
                                    <button className='flexcc dark-blur-hover pld-2 prd-1 py-1 br-5' ref={el => this.textMode = el} onClick={() => this.textView.showView()}>
                                        <p className='main-c3 mrd-3' style={{ whiteSpace: 'nowrap' }}>{translate('notebook.Normal Text')}</p>
                                        <img width={20} src='/assets/icons/note/arrowtriangle.down.fill.svg' />
                                    </button>
                                </div>
                                <div className={" px-2 " + conditionalWidth(this.props.width, { xs: ' d-none ', sm: ' d-block ' })} style={{ borderLeft: '1px solid #ddd' }} >
                                    <button className='flexcc dark-blur-hover pld-2 prd-1 py-1 br-5' ref={el => this.font = el} onClick={() => this.fontView.showView()}>
                                        <p className='main-c3 mrd-3 text-start' style={{ textOverflow: 'ellipsis', overflow: 'hidden', width: '50px' }}>Arial</p>
                                        <img width={20} src='/assets/icons/note/arrowtriangle.down.fill.svg' />
                                    </button>
                                </div>
                                <div className={" " + conditionalWidth(this.props.width, { xs: ' d-none ', md: ' d-block ' })}>
                                    <div className=" flexc px-2 " style={{ borderLeft: '1px solid #ddd' }}>
                                        <button className='flexcc dark-blur-hover p-1 br-5'>
                                            <img width={20} src='/assets/icons/note/bold.svg' />
                                        </button>
                                        <button className='flexcc dark-blur-hover p-1 br-5'>
                                            <img width={20} src='/assets/icons/note/italic.svg' />
                                        </button>
                                        <button className='flexcc dark-blur-hover p-1 br-5'>
                                            <img width={20} src='/assets/icons/note/underline.svg' />
                                        </button>
                                        <button className='flexcc dark-blur-hover p-1 br-5'>
                                            <img width={20} src='/assets/icons/text/colorpicker.png' />
                                        </button>
                                    </div>
                                </div>
                                <div className={" px-2 " + conditionalWidth(this.props.width, { xs: ' d-none ', md: ' d-block ' })} style={{ borderLeft: '1px solid #ddd' }}>
                                    <button className='flexcc dark-blur-hover p-1 br-5'>
                                        <img width={20} src='/assets/icons/note/paperclip.svg' />
                                    </button>
                                </div>
                                <div className={" px-2 " + conditionalWidth(this.props.width, { xs: ' d-none ', lg: ' d-block ' })} style={{ borderLeft: '1px solid #ddd' }}>
                                    <div className='flexc'>
                                        <button className='flexcc dark-blur-hover p-1 br-5'>
                                            <img width={20} src='/assets/icons/note/text.alignleft.svg' />
                                            <img width={14} src='/assets/icons/note/arrowtriangle.down.fill.svg' />
                                        </button>
                                        <button className='flexcc dark-blur-hover p-1 br-5'>
                                            <img width={20} src='/assets/icons/note/text.hight.svg' />
                                        </button>
                                        <button className='flexcc dark-blur-hover p-1 br-5'>
                                            <img width={20} src='/assets/icons/note/list.bullet.svg' />
                                            <img width={14} src='/assets/icons/note/arrowtriangle.down.fill.svg' />
                                        </button>
                                        <button className='flexcc dark-blur-hover p-1 br-5'>
                                            <img width={20} src='/assets/icons/note/list.number.svg' />
                                            <img width={14} src='/assets/icons/note/arrowtriangle.down.fill.svg' />
                                        </button>
                                        <button className='flexcc dark-blur-hover p-1 br-5'>
                                            <img width={20} src='/assets/icons/note/increase.indent.svg' />
                                        </button>
                                        <button className='flexcc dark-blur-hover p-1 br-5'>
                                            <img width={20} src='/assets/icons/note/decrease.indent.svg' />
                                        </button>
                                    </div>
                                </div>
                                <div className={"flexc px-2 " + conditionalWidth(this.props.width, { xs: ' d-none ', lg: ' d-block ' })} style={{ borderLeft: '1px solid #ddd' }}>
                                    <button className='flexcc dark-blur-hover p-1 br-5'>
                                        <img width={20} src='/assets/icons/note/clear-format.svg' />
                                    </button>
                                </div>
                                <div className={"flexc pld-2 " + conditionalWidth(this.props.width, { xs: ' d-block ', lg: ' d-none ' })} style={{ borderLeft: '1px solid #ddd' }}>
                                    <button className='flexcc dark-blur-hover p-1 br-5' onClick={() => this.moreOptionView.showView()}>
                                        <img width={20} src='/assets/icons/note/more.svg' />
                                    </button>
                                </div>
                            </div> */}
                            <div className='flexc'>
                                <button className='flexcc px-2'>
                                    <img className='' width={18} src='/assets/icons/email/trash-red.svg' />
                                    <p className='red-600 font-size-12'>{translate('mail.Discard')}</p>
                                </button>
                                <button onClick={() => this.sendMail()} className='flexcc px-2 dark-blur-hover'>
                                    <img className='' width={18} src='/assets/icons/email/sent-gray.svg' />
                                    <p className='gray-600 font-size-12'>{translate('mail.Send')}</p>
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* <div>
                        <textarea onChange={(e) => this.setBody(e)} value={this.state.body} className='w-100 p-3' style={{ border: 'none', outline: "none", height: "100vh" }} placeholder={translate('mail.Write your email here')}></textarea>
                    </div> */}
                </div>
                <FixedView ref={(el) => (this.moreFixedView = el)} nodeRef={this.moreCurrentNode} showFocus={false} xOffset={40} topOffset={0} zIndex={10}>
                    <div className='shadow-2 py-2 br-10' style={{ backgroundColor: "#fff", width: "max-Content" }}>
                        {this.state.tools.map((prop, index) => {
                            return (
                                <div className="blur-back flexc flex-column hover-fields cursor-pointer px-2 py-1" style={{ alignItems: "flex-start", }}>
                                    <div className='d-flex flex-column'>
                                        <button className='flexc px-2 mx-1  br-10 py-1' onClick={() => this.setState({ showformat: !this.state.showformat })}>
                                            <p className='font-size-12 ' style={{ color: '#222', whiteSpace: "nowrap" }}>{checkTranslation(prop.title)}</p>
                                        </button>

                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </FixedView>
            </div>
        )
    }
}
